export default "__VITE_ASSET__1bc0162a__"